import { render, staticRenderFns } from "./MyKPIList.vue?vue&type=template&id=7135a6e2&scoped=true&"
import script from "./MyKPIList.vue?vue&type=script&lang=js&"
export * from "./MyKPIList.vue?vue&type=script&lang=js&"
import style0 from "./MyKPIList.vue?vue&type=style&index=0&id=7135a6e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7135a6e2",
  null
  
)

export default component.exports